import type { DeviceEnrolment } from "@/types";

/**
 * A device nobody has used for three months.
 *
 * Not revoked automatically. A studio that runs a course twice a year would
 * lose every device between terms, and re-enrolling thirty phones is somebody's
 * afternoon. Flagged, so the choice is a person's.
 */
export const STALE_DEVICE_DAYS = 90;

export function isStale(device: DeviceEnrolment, now: number): boolean {
  if (device.revokedAt) return false;
  const last = Date.parse(device.lastSeenAt ?? device.enrolledAt);
  if (!Number.isFinite(last)) return false;
  return now - last > STALE_DEVICE_DAYS * 86_400_000;
}
